import { Link } from 'react-router-dom';


export default function Welcome() {
 

  return (
    

      <div className="min-h-screen p-8 bg-gray-50 dark:bg-gray-900 text-black dark:text-white transition-colors">
        <h1 className="text-3xl font-bold text-black dark:text-green-500 mb-4">
          Welcome to Q & E Admins 👋
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Link to="/dashboard/blog" className="block">
            <div className="p-6 bg-white dark:bg-gray-800 rounded shadow hover:shadow-lg transition">
              <h2 className="text-xl font-semibold mb-2">📝 Blog Posts</h2>
              <p>Create, edit, and manage your blog content.</p>
            </div>
          </Link>
          <Link to="/dashboard/news" className="block">
            <div className="p-6 bg-white dark:bg-gray-800 rounded shadow hover:shadow-lg transition">
              <h2 className="text-xl font-semibold mb-2">📰 News Updates</h2>
              <p>Share company updates and announcements.</p>
            </div>
          </Link>
        </div>
      </div>
    
  );
}
